import https from "@/lib/https";
import type {
  GoogleLoginPayload,
  LoginPayload,
  TokenData,
  ProfileDetail,
} from "@/interface/auth";
import type { ApiResponse } from "@/interface/common";

const AUTH_LOGIN_URL = "/api/auth/login/";
const AUTH_GOOGLE_URL = "/api/auth/social/google-oauth2/";
const AUTH_LOGOUT_URL = "/api/auth/logout/";
const AUTH_ME_URL = "/api/profiles/";

export const loginApi = async (
  payload: LoginPayload,
): Promise<ApiResponse<TokenData>> => {
  return await https.post<ApiResponse<TokenData>>(AUTH_LOGIN_URL, payload);
};

export const googleLoginApi = async (
  payload: GoogleLoginPayload,
): Promise<ApiResponse<TokenData>> => {
  return await https.post<ApiResponse<TokenData>>(AUTH_GOOGLE_URL, payload);
};

export const logoutApi = async (refreshToken: string): Promise<any> => {
  return await https.post(AUTH_LOGOUT_URL, { refresh: refreshToken });
};

export const getAuthMeApi = async (): Promise<ApiResponse<ProfileDetail>> => {
  return await https.get<ApiResponse<ProfileDetail>>(AUTH_ME_URL);
};
